import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const CategoryItem = (props) => {
	const { text, onClick, small, withArrow, arrowOnly, arrowLabel, rightLabel, className, icon: Icon } = props

	const arrow = withArrow && (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="currentColor"
			className="bi bi-chevron-right item-arrow"
			viewBox="0 0 16 16"
			{...(arrowOnly && {
				onClick: onClick,
				role: 'button',
				tabIndex: 0,
				'aria-label': arrowLabel,
				onKeyDown: (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick?.(e) } },
			})}
		>
			<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
		</svg>
	)

	const content = (
		<>
			<span className="category-item-label">
				{ Icon &&
					<span className='category-item-icon'><Icon /></span>
				}
				{ text }
			</span>
			{ (withArrow || rightLabel) &&
				<span className="category-item-right">
					{ rightLabel &&
						<label className='right-label'>{rightLabel}</label>
					}
					{ arrow }
				</span>
			}
		</>
	)

	const itemClassName = classNames('category-item', { [className]: className, 'flex-item' : (withArrow || rightLabel), 'thin': small, 'has-icon': Icon })

	if (arrowOnly) {
		return (
			<div className={itemClassName}>
				{content}
			</div>
		)
	}

	return (
		<button className={itemClassName} onClick={onClick}>
			{content}
		</button>
	)
}

CategoryItem.propTypes = {
	text: PropTypes.string.isRequired,
	withArrow: PropTypes.bool,
	arrowOnly: PropTypes.bool,
	arrowLabel: PropTypes.string,
	onClick: PropTypes.func,
	icon: PropTypes.elementType,
}

CategoryItem.defaultProps = {
	withArrow: false,
	arrowOnly: false,
};

export default CategoryItem;
